// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__6-R6B","buttonPrimary":"Button_buttonPrimary__2Nx2L","buttonSecondary":"Button_buttonSecondary__3BBR6"};